/**
 * Where the app sends people for help.
 *
 * This replaced the Zoho Desk ASAP chat widget, which used to be injected on
 * every page from `index.html`. A CPU profile of one Menu Cycle day change
 * found 6.3% of the time inside the widget's `murphy.min.js` — it ran on every
 * screen whether or not anyone opened it. See
 * `src/docs/MCModify-Grid-Benchmark.md` §7.2.
 *
 * These are the same Zoho Desk help center the widget fronted (org 704965408,
 * portal `psibuffalo`), just linked rather than embedded — so the content and
 * the people answering are unchanged.
 */

/** Public knowledge base. Titled "PSI Buffalo | Knowledge Base" at the far end,
 *  which is why the in-app label reads "Knowledge Base" and not something we
 *  invented. */
export const SUPPORT_KB_URL = 'https://support.psibuffalo.com/portal/en/kb';

/** Ticket submission. The ASAP widget offered this inline; nothing in the app
 *  links here yet, so raising a ticket now means going through the KB portal's
 *  own navigation. Wire it up if in-app ticket creation is wanted back. */
export const SUPPORT_NEW_TICKET_URL = 'https://support.psibuffalo.com/portal/en/newticket';

/** Dietech support's phone number and email address, as Help > Support Hours shows them (and the
 *  welcome tour's last page). */
export const SUPPORT_PHONE = '(716) 565-9400';
export const SUPPORT_EMAIL = 'support@psibuffalo.com';
